import { client } from '@/common-utils/libraries/axios/axios';
import CONTRACT_ACCESS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateLabel = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractAccessId, label }) => {
            return client.put(replaceParameters(CONTRACT_ACCESS.UPDATE_LABEL.url, { contractAccessId }), { label });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateLabel;